import { FormEvent, useState } from "react";
import { Layout } from "../components/Layout";
import { Panel } from "../components/Panel";
import { isFrontendDemoAuthEnabled, login } from "../lib/api/authClient";
import { t, useWorkspaceLanguage } from "../lib/i18n";

export function Login() {
  const language = useWorkspaceLanguage();
  const labels = t(language).login;
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | undefined>();
  const [isSubmitting, setIsSubmitting] = useState(false);

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setIsSubmitting(true);
    const result = await login(email, password);
    setIsSubmitting(false);

    if (!result.ok) {
      setError(result.message);
      return;
    }

    window.location.assign(result.redirectTo ?? "/workspace");
  }

  return (
    <Layout
      title={labels.title}
      description={labels.description}
    >
      <Panel title={labels.panelTitle} variant="accent">
        <form className="form" aria-label={labels.formLabel} onSubmit={handleSubmit}>
          <label htmlFor="email">{labels.email}</label>
          <input
            id="email"
            name="email"
            type="email"
            placeholder="name@unternehmen.de"
            autoComplete="email"
            value={email}
            onChange={(event) => {
              setEmail(event.target.value);
              setError(undefined);
            }}
            required
          />
          <label htmlFor="password">{labels.password}</label>
          <input
            id="password"
            name="password"
            type="password"
            placeholder={labels.passwordPlaceholder}
            autoComplete="current-password"
            value={password}
            onChange={(event) => {
              setPassword(event.target.value);
              setError(undefined);
            }}
            required
          />
          <p className="form-note">
            {labels.note}
          </p>
          <p className="form-note">
            {labels.resetNote}
          </p>
          {isFrontendDemoAuthEnabled() ? <p className="form-note">{labels.demoActive}</p> : null}
          {error ? (
            <p className="form-error" role="alert">
              {error}
            </p>
          ) : null}
          <button className="button button-primary" type="submit" disabled={isSubmitting}>
            {labels.submit}
          </button>
        </form>
      </Panel>
    </Layout>
  );
}
